var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DocumentForm',{attrs:{"is-master":""}},[_c('p',[_vm._v("Use the form below to set the default values for this document. The form will be prepopulated with these values when you create a new document.")])])}
var staticRenderFns = []

export { render, staticRenderFns }